			// Swiper共通オプション（フェード）
			document.addEventListener('DOMContentLoaded', function () {
				const swiper = new Swiper('.prodBox .swiper', {
					loop: true,
					effect: 'fade',
					fadeEffect: {
						crossFade: true,
					},
					speed: 2000,
					slidesPerView: 1,
					autoplay: {
						delay: 2500,
						pauseOnMouseEnter: true,
						disableOnInteraction: false,
					},
				});
			});

			document.addEventListener('DOMContentLoaded', () => {
				const images = document.querySelectorAll('.js-tap-img');

				if (images.length === 0) return;

				// Intersection Observerのオプション設定
				const observerOptions = {
					root: null, // ビューポートを基準にする
					// 画面の下半分（50%）をトリガーポイントにするためのマスク設定
					rootMargin: '0px 0px -50% 0px',
					threshold: 0, // 要素が境界線を1ピクセルでも越えたら実行
				};

				const observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							// 画像が画面の中央より上に入った時
							entry.target.classList.add('is-active');
						} else {
							// 画像が画面の中央より下に戻った時
							entry.target.classList.remove('is-active');
						}
					});
				}, observerOptions);

				// 対象の要素をすべて監視
				images.forEach((image) => observer.observe(image));
			});

